import { getActivePinia } from "pinia"
import { ExtendedPinia } from "@/interface"

import { AuthStore } from "@/stores/authentication"
import { CommonStore } from "@/stores/common"
import { ContactStore } from "@/stores/contact"
import { ContractStore } from "@/stores/contract"
import { CustomerStore } from "@/stores/customer"
import { InvoiceSituationStore } from "@/stores/invoiceSituation"
import { InvoicingStore } from "@/stores/invoicing"
import { ListStore } from "@/stores/lists"
import { NewOrderStore } from "@/stores/newOrder"
import { ProductStore } from "@/stores/product"
import { PromotionStore } from "@/stores/promotion"
import { RecoveryStore } from "@/stores/recovery"
import { SettingStore } from "@/stores/setting"

const getStore = (name: string) => {
    const activePinia = getActivePinia() as ExtendedPinia 
    return activePinia?._s.get(name) ?? null
}

export const getAuthenticationStore = () => {
    return (getStore('authentication') as AuthStore|null)
}

export const getCommonStore = () => {
    return (getStore('common') as CommonStore|null)
}

export const getContactStore = () => {
    return (getStore('contact') as ContactStore|null)
}

export const getContractStore = () => {
    return (getStore('contract') as ContractStore|null)
}

export const getCustomerStore = () => {
    return (getStore('customer') as CustomerStore|null)
}

export const getInvoiceSituationStore = () => {
    return (getStore('invoiceSituation') as InvoiceSituationStore|null) 
}

export const getInvoicingStore = () => {
    return (getStore('invoicing') as InvoicingStore|null) 
}

export const getListStore = () => {
    return (getStore('lists') as ListStore|null) 
}

export const getNewOrderStore = () => {
    return (getStore('newOrder') as NewOrderStore|null) 
}

export const getProductStore = () => {
    return (getStore('product') as ProductStore|null) 
}

export const getPromotionStore = () => {
    return (getStore('promotion') as PromotionStore|null) 
}

export const getRecoveryStore = () => {
    return (getStore('recovery') as RecoveryStore|null) 
}

export const getSettingStore = () => {
    return (getStore('setting') as SettingStore|null) 
}